<template>
  <div>
    <v-layout v-if="adds==1" pa-2 wrap justify-center>
      <v-flex xs12 sm12 md10>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 pt-1>
            <v-img src="./../../assets/images/a5.jpg" height="200px" cover class="white--text">
              <v-layout wrap>
                <v-flex text-left>
                  <v-btn
                    small
                    dark
                    tile
                    depressed
                    :ripple="false"
                    color="#E4B955"
                    class="text-capitalize"
                  >
                    <span style="font-family:opensansbold;font-size:12px;">New Products</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-12 pr-5 text-right>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-if="adds==2" pa-2 wrap justify-center>
      <v-flex xs12 sm12 md10>
        <v-layout wrap>
          <v-flex xs12 sm12 md6 pt-1>
            <v-img src="./../../assets/images/a4.jpg" height="200px" cover class="white--text">
              <v-layout wrap>
                <v-flex text-left>
                  <v-btn
                    small
                    dark
                    tile
                    depressed
                    :ripple="false"
                    color="#E4B955"
                    class="text-capitalize"
                  >
                    <span style="font-family:opensansbold;font-size:12px;">New Products</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-12 pr-5 text-right>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm12 md6 pt-1>
            <v-img src="./../../assets/images/a5.jpg" height="200px" cover class="white--text">
              <v-layout wrap>
                <v-flex text-left>
                  <v-btn
                    small
                    dark
                    tile
                    depressed
                    :ripple="false"
                    color="#E4B955"
                    class="text-capitalize"
                  >
                    <span style="font-family:opensansbold;font-size:12px;">New Products</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-12 pr-5 text-right>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-if="adds==3" pa-2 wrap justify-center>
      <v-flex xs12 sm12 md10>
        <v-layout wrap>
          <v-flex xs12 sm12 md4 pt-1>
            <v-img src="./../../assets/images/a3.jpg" height="200px" cover class="white--text">
              <v-layout wrap>
                <v-flex text-left>
                  <v-btn
                    small
                    dark
                    tile
                    depressed
                    :ripple="false"
                    color="#E4B955"
                    class="text-capitalize"
                  >
                    <span style="font-family:opensansbold;font-size:12px;">New Products</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-12 pr-5 text-right>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm12 md4 pt-1>
            <v-img src="./../../assets/images/a4.jpg" height="200px" cover class="white--text">
              <v-layout wrap>
                <v-flex text-left>
                  <v-btn
                    small
                    dark
                    tile
                    depressed
                    :ripple="false"
                    color="#E4B955"
                    class="text-capitalize"
                  >
                    <span style="font-family:opensansbold;font-size:12px;">New Products</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-12 pr-5 text-right>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm12 md4 pt-1>
            <v-img src="./../../assets/images/a5.jpg" height="200px" cover class="white--text">
              <v-layout wrap>
                <v-flex text-left>
                  <v-btn
                    small
                    dark
                    tile
                    depressed
                    :ripple="false"
                    color="#E4B955"
                    class="text-capitalize"
                  >
                    <span style="font-family:opensansbold;font-size:12px;">New Products</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap fluid fill-height>
                <v-flex align-self-end pb-12 pr-5 text-right>
                  <v-btn small dark tile depressed :ripple="false" color="#63028F">
                    <span
                      style="font-family:opensansregular;font-size:12px;"
                      class="text-capitalize"
                    >Shop Now</span>
                    <span>
                      <v-icon size="15">mdi-chevron-right</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["adds"],
  data() {
    return {
      advertisements: 0,
    };
  },
  beforeMount() {},
  methods: {},
};
</script>